import { render, staticRenderFns } from "./check-ideal-people.html?vue&type=template&id=668a95be&scoped=true&external"
import script from "./check-ideal-people.js?vue&type=script&lang=js&external"
export * from "./check-ideal-people.js?vue&type=script&lang=js&external"
import style0 from "./check-ideal-people.scss?vue&type=style&index=0&id=668a95be&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668a95be",
  null
  
)

export default component.exports